export class CompanyPropertiesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyProperties() {
    return this.#http.get('/CompanyProperties');
  }

  async getCompanyPropertyDefinitions() {
    return this.#http.get('/CompanyPropertyDefinitions');
  }

  async getCompanyPropertiesInternal({ companyId }) {
    return this.#http.get(`/CompanyProperties/internal/${companyId}`);
  }

  async createCompanyProperty({ propertyName, propertyValue }) {
    return this.#http.post('/CompanyProperties', { propertyName, propertyValue });
  }

  async createCompanyPropertyInternal({ companyId, propertyName, propertyValue }) {
    return this.#http.post('/CompanyProperties/internal', {
      companyId,
      propertyName,
      propertyValue,
    });
  }

  async deleteCompanyProperty({ propertyName }) {
    return this.#http.delete(`/CompanyProperties/${propertyName}`);
  }

  async deleteCompanyPropertyInternal({ companyId, propertyName }) {
    return this.#http.delete(`/CompanyProperties/internal/${companyId}/${propertyName}`);
  }
}
